import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://www.sprizziamoci.it";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function useSEO(title, description) {
  const { pathname } = useLocation();
  useEffect(() => {
    const url = `${SITE}${pathname === "/" ? "/" : pathname}`;
    document.title = title;
    upsertMeta("name", "description", description || "");
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description || "");
    upsertMeta("property", "og:url", url);
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description || "");
    upsertCanonical(url);
  }, [title, description, pathname]);
}
